export default "__VITE_ASSET__D67uG5If__"